export const WATERFALL_CELL_SKELETON_LAYOUT_STYLES = {
  paddingLeft: 0,
  '.GridSkeleton-row': { height: '100%' },
  '.GridSkeleton-cell': { height: '100% !important', margin: 0 },
} as const;

// Mask values in the settled tables instead of replacing their measured layout.
// This preserves row spans, horizontal scroll, currency labels, and page height.
export const WATERFALL_RECALCULATION_STYLES = {
  pointerEvents: 'none',
  userSelect: 'none',
  '.data-grid .cell.visible:not(.legend)': {
    color: 'transparent !important',
    position: 'relative',
    '& > *:not(.waterfall-cell-skeleton)': { visibility: 'hidden' },
    '.waterfall-cell-skeleton': {
      ...WATERFALL_CELL_SKELETON_LAYOUT_STYLES,
      inset: '2px',
      position: 'absolute',
    },
  },
  '@media (prefers-reduced-motion: reduce)': {
    '.waterfall-cell-skeleton .MuiSkeleton-root': { animation: 'none' },
  },
} as const;
